module.exports = __webpack_public_path__ + "img/106.206cda09.svg";